export class Calendar{
  dayOff: any;
  dayDesc: any;
}
